<template>
    <div class="background">
        <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
            <el-row class="ticket_row">票种管理</el-row>
            <el-row>
                <el-col :span="12" style="padding-left: 20px">
                    <div>

                        <div class="ticket_col2">*当前票种名称</div>
                        <el-input v-model="inputTicketName" placeholder="请输入内容"></el-input>

                    </div>
                    <div>

                        <div class="ticket_col2">*分类</div>
                        <el-dropdown>
  <span class="el-dropdown-link">
    下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>地球档案</el-dropdown-item>
                                <el-dropdown-item>地球档案1</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </div>
                    <div>

                        <div class="ticket_col2">*票价设置</div>
                        <el-col :span="5">
                            <el-input v-model="inputOriginalPrice" placeholder="请输入原价"></el-input>
                        </el-col>
                        <el-col :span="5">
                            <el-input v-model="inputPrice" placeholder="请输入票价"></el-input>
                        </el-col>

                    </div>
                    <div>

                        <div class="ticket_col2">*库存</div>
                        <div class="ticket_col">1</div>

                    </div>
<div>

                        <div class="ticket_col2">*当前票种类型</div>
                        <el-input v-model="inputTicketType" placeholder="请输入类型"></el-input>

                    </div>

                </el-col>
                <el-col :span="12" style="padding-left: 10px">
                    <div class="ticket_col3">
                        首页卡片入口
                        <el-switch
                            v-model="value"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </div>
                    <div class="ticket_col1">
                        <div class="ticket_col3">首页卡片图</div>
                        <div style="margin-left: 30%">
                            <el-upload
                                action="https://jsonplaceholder.typicode.com/posts/"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </div>
                        <div class="ticket_col3">
                            核销地点信息
                            <el-input
                                style="padding-top: 10px"
                                type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="textarea">
                            </el-input>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <div style="text-align: center">
                    <el-button @click="button">取消</el-button>
                    <el-button @click="button">添加票种</el-button>
                </div>
            </el-row>
            <el-row>
            </el-row>
        </div>
    </div>
</template>

<script>
import $ from "jquery";

export default {
    name: "createTicketType",
    data() {
        return {
            tableData: {},
            num: 4,
          inputTicketName:'',
          inputOriginalPrice:'',
          inputPrice:'',
          inputTicketType:'',
            options: [{
                value: '选项1',
                label: '黄金糕'
            }, {
                value: '选项2',
                label: '双皮奶',
                disabled: true
            }, {
                value: '选项3',
                label: '蚵仔煎'
            }, {
                value: '选项4',
                label: '龙须面'
            }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            value: ''
        }
    },
    created() {

    },
    methods: {
        button() {
            // this.$router.push(`ticketTypeList`)
    var selectedValue = localStorage.getItem('selectedValue');
      var inputTicketName = this.inputTicketName
      var inputOriginalPrice = this.inputOriginalPrice
      var inputPrice = this.inputPrice
          var inputTicketType = this.inputTicketType
      // var value1 = this.value1
      // const year = value1.getFullYear();
      // // 获取月，需要注意月份是从0开始计数的，所以要加1
      // const month = String(value1.getMonth() + 1).padStart(2, '0');
      // // 获取日
      // const day = String(value1.getDate()).padStart(2, '0');
      // // 组合成指定格式的日期字符串
      // var formattedDate = `${year}-${month}-${day}`;
      // console.log('formattedDate：', formattedDate)
      // var url = this.url
      // console.log('inputName：', inputName)
      // console.log('inputDec：', inputDec)
      // console.log('inputAddress：', inputAddress)
      var data = {
        "name": inputTicketName,
        "originalPrice": inputOriginalPrice,
        "price":inputPrice,
        "ticketType":inputTicketType,
        "status":"已上架"
      }
      console.log('json_data：', data)
      $.ajax({
        url: this.$settings.BASE_URL + 'create/ticket_type/info',
        type: 'POST',
        dataType: 'json',
        data: {
          "site_id": selectedValue,
          "content_id":"acd5db617fa84f7980f91aa931257169",
          "ticket_data": JSON.stringify(data),
          "password": "hotpoorinchina"
        },
        success: (res) => {
          console.log('获取到的数据：', res)
          if (res.info == 'ok') {
            this.$router.push(`ticketTypeList`)
          } else {
            alert(res.about)
          }
        },
        error: (error) => {
          console.log('请求失败：', error)

        }
      })
    }
    },
    mounted() {
        var ticketTypeId = this.$route.query.id;
        var that = this
        $.ajax({
            // url: 'https://dreamportal.nextscene.cn/api/ticket/info',
            url: 'http://127.0.0.1:8002/api/ticket/info',
            type: 'GET',
            dataType: 'json',
            success: (res) => {
                console.log('获取到的数据：', res)
                let tableData = {}
                if (res.info == 'ok') {
                    res.orderList.forEach(function (ticketType) {
                        const result = ticketType.name.match(/【([^】]+)】/);
                        if (result && result.length > 1) {
                            var ticket_type = result[1];
                            console.log(ticket_type); // 输出：早鸟票
                        }
                        if (ticketType.id == ticketTypeId) {
                            tableData = {
                                id: ticketType.id,
                                info: ticketType.name,
                                category: '地球档案',
                                price: ticketType.price,
                                originalPrice: ticketType.originalPrice,
                                max_num: ticketType.max_num,
                                ticketType: ticket_type,
                                status: ticketType.status
                            }
                            that.num = ticketType.max_num
                        }

                    })
                    this.tableData = tableData
                }
            },
            error: (error) => {
                console.log('请求失败：', error)
            }
        })

    },
}
</script>

<style scoped>
.ticket_col {
    width: Fill (375px) px;
    height: Fixed (52px) px;
    padding: 8px 16px 8px 16px;
    gap: 10px;
    border-radius: 8px 8px 8px 8px;
    opacity: 0px;
    background: #EFF1F999;
    margin: 10px 10px 10px 10px;
}

.ticket_col1 {
    width: 380px;
    height: 422px;
    top: 211px;
    left: 775px;
    gap: 0px;
    border-radius: 18px 18px 18px 18px;
    opacity: 0px;
    border: 2px solid #2D334A4D;
    margin: 10px 0 0 0;
}

.ticket_row {
    width: 88px;
    height: 31px;
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 600;
    line-height: 30.8px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 20px 0 0 20px;
}

.ticket_col2 {
    width: 122px;
    height: 25px;
    font-family: PingFang SC;
    font-size: 17px;
    font-weight: 600;
    line-height: 25.2px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #8A96B1;
    margin: 20px 0 20px 20px;
}

.ticket_col3 {
    width: 236px;
    height: 25px;
    top: 231px;
    left: 798px;
    gap: 0px;
    opacity: 0px;
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 600;
    line-height: 25.2px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #8A96B1;
    padding: 10px 0 10px 10px

}

.ticket_col4 {
    font-family: PingFang SC;
    font-size: 13px;
    font-weight: 400;
    line-height: 21px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #8A96B1;

}

.background {
    background-color: #F4F5FA;
}

.iStyle1 {
    width: Fixed (180px) px;
    height: Hug (62px) px;
    padding: 17px 16px 17px 16px;
    gap: 10px;
    border-radius: 12px 12px 12px 12px;
    opacity: 0px;
    border: 2px solid #5C16F2;
    text-align: center;
}

.iStyle2 {

}
</style>
